import React, { useRef } from 'react';
import ReadArticleList from "./ReadArticleList/ReadArticleList";
import Slider from "react-slick";
import { useSelector} from "react-redux";
import ReadOffCanvas from "./ReadOffCanvas";
import { Animate  } from "react-simple-animate";
import Pointer from "../../Components/Pointer";
import ReadFeaturedCard from "./ReadFeaturedCard";
import stripHtml from "../../Components/StripHTML";
import {v4 as uuidv4} from "uuid";
import FeaturedSlider from "./ReadFeatured/FeaturedSlider";
import ReadNav from "./ReadNav";

export default function Read(props) {

    const {reads} = useSelector((state) => state.reads)
    const slider = useRef()

    const { readOffCanvasIsActive } = useSelector((state) => state.navBar)

    const featuredReads = reads && reads.filter((read) => read.sticky === true);
    const nonFeaturedReads = reads && reads.filter((read) => read.sticky === false);


    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        rows: 1,

    };

    //slick slider functions
    const getNextSlide = (c) =>{
        if (slider.current) {
            slider.current.slickNext(c);
        }
    }
    const getPrevSlide = (c) =>{
        if (slider.current) {
            slider.current.slickPrev(c);
        }
    }



    return (
        <>
            {readOffCanvasIsActive ? <ReadOffCanvas /> :

            <div className=" read flex flex-col h-full bg-purple-dashboard  overflow-y-scroll   px-4 gap-8  ">
                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <ReadNav getNextSlide={getNextSlide} getPrevSlide={getPrevSlide}/>
                </Animate>

                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <FeaturedSlider featuredReads={featuredReads} settings={settings} slider={slider}/>
                </Animate>

                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <ReadArticleList nonFeatureReads={nonFeaturedReads && nonFeaturedReads}/>
                </Animate>
            </div>

            }
        </>
    );
}

